import { render } from "./venue-gallery.vue?vue&type=template&id=16596ea5"
import script from "./venue-gallery.vue?vue&type=script&lang=js"
export * from "./venue-gallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__